import React from "react";
import Page from "../../../layout/web/Page";
import Title from "../../../components/Common/Title";
import Connector from "../../../redux/connector";
import {GetUserToken} from "../../../api/token";
import PluginAddDeleteList from "../../../components/Common/PluginAddDeleteList2";
import {PostToPbx} from "../../../api/http-post";
import {fetchDataEntity} from "../../../api/entity-data";

class ContainerRentalLogPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Data: [],
            Companies: [],
            Modules: [],
            Clients: [],
            Items: [],
            Configs:[],
            isLoading: false,
            company: "",
            component: "list",
            newEntry: {},
        }
    }

    componentDidMount = async () => {
        await fetchDataEntity("Companies", "client/entity", "company", this)
        await this.loadInitialData()
    }

    loadInitialData = async () => {
        await this.loadData("modules", "Modules");
        await this.loadData("SettingInvoiceServiceDebtors", "Clients");
        await this.loadData("SettingInvoiceServiceItem", "Items");
        await this.loadData("ContainerRentalConfig", "Configs");
    }
    loadData = async (targetEntity, stateKey) => {
        let _this = this;
        let userInfo = GetUserToken();
        let table = targetEntity;
        let hub = {};
        hub.Org = userInfo.Org;
        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = {};
        post.Params = {}
        post.Entity = table;
        let endpoint = "/common/entity/" + table + "/list";
        this.setState({
            isLoading: true,
        })

        await PostToPbx(post, endpoint, async (data) => {
            await _this.setState({
                [stateKey]: data.RESULT
            })
        });
    }
    getCompanyList = () => {
        let ls = [];
        for (let i in this.state.Companies) {
            let row = this.state.Companies[i];
            ls.push({
                key: row.CustomerNumber,
                val: row.Name,
            });
        }
        return ls;
    }
    getClientOption = () => {
        let ls = [];
        for (let i in this.state.Clients) {
            let row = this.state.Clients[i];
            if (row.org === this.state.newEntry.selectedCompany) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getItemOption = () => {
        let ls = [];
        for (let i in this.state.Items) {
            let row = this.state.Items[i];
            if (row.org === this.state.newEntry.selectedCompany && row.client === this.state.newEntry.selectedClient) {
                ls.push({
                    key: row.name,
                    val: row.name
                });
            }
        }
        return ls;
    }
    getConfigOption = () => {
        let ls = [];
        for (let i in this.state.Configs) {
            let row = this.state.Configs[i];
            if (row.org === this.state.newEntry.selectedCompany && row.client === this.state.newEntry.selectedClient && row.item === this.state.newEntry.selectedItem) {
                ls.push({
                    key: row.itemnumber,
                    val: row.description
                });
            }
        }
        return ls;
    }

    submitLog = async (data) => {
        if (!window.confirm("Are you sure?")) {
            return
        }
        let post = {
            org: this.state.newEntry.selectedCompany,
            client: this.state.newEntry.selectedClient,
            item: this.state.newEntry.selectedItem,
            PayloadLogs: [],

        }
        post.PayloadLogs.push({
            Date: data.logdate,
            quantity: parseFloat( data.quantity),
            itemNumber: data.description,
        });
        console.log("@@@@@@@On Submit > ", post)
        console.log("@@@@@@@On this.state. > ", this.state)
        let endpoint = "/containerrental/workflows/new/logs";
        await PostToPbx(post, endpoint, async (data) => {
            alert("Feeback submit : " + JSON.stringify(data))
        });
    }

    render() {

        const companyOptions = this.getCompanyList();
        const clientOptions = this.getClientOption();
        const itemOptions = this.getItemOption();
        const configOptions = this.getConfigOption()
        return (
            <Page {...this.props}>
                <div style={{
                    minHeight: "100%",
                    maxHeight: "100%",
                }}>
                    <Title style={styles.title}>Setup Container Rental Log</Title>
                    <div style={{minWidth: "100%", padding: 10}}>
                        <PluginAddDeleteList
                            _this={this}
                            targetEntity={"ContainerRentalLog"}
                            depending={{
                                "org": {
                                    targetKey: "CustomerNumber",
                                    displayKey: "Name",
                                    storageTable: "Companies"
                                }
                            }}
                            fields={[
                                {
                                    name: "org",
                                    dataType: "option",
                                    required: true,
                                    label: "Company",
                                    options: companyOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"},
                                    formEntry: false,
                                },
                                {
                                    name: "client",
                                    dataType: "option",
                                    required: true,
                                    label: "Debtor",
                                    options: clientOptions,
                                    depending: {stateKey: "org", displayKey: "Name", storageTable: "Companies"},
                                    formEntry: false,

                                },

                                {
                                    name: "item",
                                    dataType: "option",
                                    required: true,
                                    label: "Item name",
                                    options: itemOptions,
                                    formEntry: false,

                                },
                                {
                                    name: "description",
                                    dataType: "option",
                                    required: true,
                                    label: "Descriptions",
                                    options: configOptions,

                                },
                                {
                                    name: "logdate",
                                    dataType: "date",
                                    required: true,
                                    label: "Date",
                                    options: []
                                },

                                {
                                    name: "quantity",
                                    dataType: "float",
                                    required: true,
                                    label: "Quantity",
                                    options: [],
                                },

                                {
                                    name: "description",
                                    dataType: "string",
                                    required: true,
                                    label: "Description",
                                    options: [],
                                    formEntry: false,
                                },
                                {
                                    name: "unitprice",
                                    dataType: "float",
                                    required: true,
                                    label: "Unit Price",
                                    options: [],
                                    formEntry: false,
                                },
                                {
                                    name: "amount",
                                    dataType: "float",
                                    required: true,
                                    label: "Amount Excl.Vat",
                                    options: [],
                                    formEntry: false,
                                },

                            ]}
                            deleteKeys={[
                                {key: "org", type: "string"},
                                {key: "client", type: "string"},
                                {key: "item", type: "string"},
                                {key: "logdate", type: "string"},
                            ]}
                            stateArray={"Data"}
                            table={"ContainerRentalLog"}
                            addFormText={"Water Tanker Config"}
                            stepTitle={"Setup Water Tanker Config"}

                            filterByCompany={true}
                            displayRules={[
                                {rowKey: "org", stateKey: "selectedCompany"},
                                {rowKey: "client", stateKey: "selectedClient"},
                                {rowKey: "item", stateKey: "selectedItem"},
                            ]}
                            extraFilters={[
                                {
                                    recordKey: "key",
                                    recordValue: "val",
                                    stateKey: "client",
                                    filterRecordKey: "client",
                                    filterStateKey: "selectedClient",
                                    allowBlank: true,
                                    name: "selectedClient",
                                    label: "Debtor",
                                    options: clientOptions,
                                    errorMsg: "Sorry you can't save, Please select your client!"
                                },
                                {
                                    recordKey: "key",
                                    recordValue: "val",
                                    stateKey: "item",
                                    filterRecordKey: "item",
                                    filterStateKey: "selectedItem",
                                    allowBlank: true,
                                    name: "selectedItem",
                                    label: "Item | Job description",
                                    options: itemOptions,
                                    errorMsg: "Sorry you can't save, Please select your client!"
                                },

                            ]}
                            postFunc={this.submitLog}

                        />

                    </div>
                </div>
            </Page>
        )
    }

}


export default Connector(ContainerRentalLogPage);

const styles = {
    container: {},
    title: {
        minWidth: "100%",
        borderBottomWidth: 1,
        borderColor: "gray"
    }
}